import { FC } from "react";
import { Rw1LogoColored } from "../icons/RW1LogoColored";

export const LoadingPage: FC = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100vw",
      }}
    >
      <Rw1LogoColored color="text.1" height="5vw" />
    </div>
  );
};
